import { render, staticRenderFns } from "./AlmoxarifadoTab.vue?vue&type=template&id=686b4832"
import script from "./AlmoxarifadoTab.vue?vue&type=script&lang=js"
export * from "./AlmoxarifadoTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports